import React, { Component } from 'react'
import PropTypes from 'prop-types'

import MenuItem from './MenuItem'
import ServiceItem from './ServiceItem'
import SnackPack from './SnackPack'
import VirtualItem from './VirtualItem'
import VirtualKit from './VirtualKit'

class MenuItemGroup extends Component {
  state = {
    isExpanded: false,
  }

  componentDidMount() {
    const { isExpanded } = this.props
    this.setState({ isExpanded })
  }

  componentWillReceiveProps(nextProps) {
    const { isExpanded } = nextProps
    if (isExpanded !== this.props.isExpanded) {
      this.setState({ isExpanded })
    }
  }

  onToggleExpanded = () => {
    this.setState({ isExpanded: !this.state.isExpanded })
  }

  onCreateCustom = () => {
    this.props.onCreateCustom()
  }

  renderItem = (item) => {
    const {
      onSelect,
      onSelectServiceItem,
      onSelectSnackPack,
      onSelectVirtualItem,
      onSelectVirtualKit,
    } = this.props
    if (item.itemType === 'MenuItem') {
      return <MenuItem key={item.id} menuItem={item} onSelect={onSelect} />
    } else if (item.itemType === 'ServiceItem') {
      return (
        <ServiceItem
          key={item.id}
          serviceItem={item}
          onSelect={onSelectServiceItem}
        />
      )
    } else if (item.itemType === 'SnackPack') {
      return (
        <SnackPack
          key={item.id}
          snackPack={item}
          onSelect={onSelectSnackPack}
        />
      )
    } else if (item.itemType === 'VirtualItem') {
      return (
        <VirtualItem
          key={item.id}
          virtualItem={item}
          onSelect={onSelectVirtualItem}
        />
      )
    } else if (item.itemType === 'VirtualKit') {
      return (
        <VirtualKit
          key={item.id}
          virtualKit={item}
          onSelect={onSelectVirtualKit}
        />
      )
    }
  }

  render() {
    const {
      addCustomText,
      groupName,
      menuItems,
      onCreateCustom,
      hideNonCustom,
    } = this.props
    const { isExpanded } = this.state

    const customItem = {
      name: addCustomText,
      tagsDietaryPreferenceList: '',
    }

    const fullGroupName =
      groupName + (hideNonCustom ? ' (For Shipping Charges)' : '')

    return (
      <div className="mb-4">
        <div className="flex justify-between items-center">
          <p
            className="bold text-lg pb-1 relative items"
            onClick={this.onToggleExpanded}
          >
            {fullGroupName}
            {!hideNonCustom && (
              <span className={isExpanded ? 'down-arrow' : 'side-arrow'}></span>
            )}
          </p>
          {onCreateCustom && (
            <p
              className="cursor-pointer rounded py-1 px-2 border border-green-500 border-solid bold text-base text-green-500"
              onClick={() => this.onCreateCustom(customItem)}
            >
              {customItem.name}
            </p>
          )}
        </div>
        {isExpanded && (
          <ul>
            {!hideNonCustom && menuItems.map((item) => this.renderItem(item))}
          </ul>
        )}
      </div>
    )
  }
}

MenuItemGroup.propTypes = {
  addCustomText: PropTypes.string,
  className: PropTypes.string,
  groupName: PropTypes.string,
  isExpanded: PropTypes.bool,
  hideNonCustom: PropTypes.bool,
  menuItems: PropTypes.arrayOf(PropTypes.object),

  onCreateCustom: PropTypes.func,
  onSelect: PropTypes.func,
  onSelectServiceItem: PropTypes.func,
  onSelectSnackPack: PropTypes.func,
  onSelectVirtualItem: PropTypes.func,
  onSelectVirtualKit: PropTypes.func,
}

export default MenuItemGroup
